import qs from 'qs'
import client from './client'
import { LIMIT_PER_PAGE } from '@/configs/app'

export default {
    getIcreated(pageNum, pageSize) {
        return client.get('/contest/icreated', {
            params: {
                paging: true,
                pageNum: pageNum || 1,
                limit: pageSize || LIMIT_PER_PAGE
            }
        })
    },
    getJoined(pageNum, pageSize) {
        return client.get('/contest/ijoind', {
            params: {
                paging: true,
                pageNum: pageNum || 1,
                limit: pageSize || LIMIT_PER_PAGE
            }
        })
    },
    getDetail(id) {
        return client.post('/contest/detail', qs.stringify({
            id
        }))
    },
    startSignin(contestId) {
        return client.post('/contest/start/signin', qs.stringify({
            contestId
        }))
    },
    getAllPlayer(contestId,searchContent) {
        return client.post('/contest/allPlayer', qs.stringify({
            contestId,
            searchContent
        }))
    },
    getIgnoreAllPlayer(contestId) {
        return client.post('/contest/lottery/rank/list', qs.stringify({
            contestId,
        }))
    },
    getAllJudge(contestId) {
        return client.post('/contest/allJudge', qs.stringify({
            contestId
        }))
    },
    confirmPlayer(contestId, joinId) {
        return client.post('/contest/confirmPlayer', qs.stringify({
            contestId,
            joinId
        }))
    },
    proxyPlayerJoin(contestPlayer){
        return client.post('/contest/player/join/proxy',contestPlayer)
    },
    deletePlayer(contestId, joinId) {
        return client.post('/contest/deletePlayer', qs.stringify({
            contestId,
            joinId
        }))
    },
    endSignin(contestId) {
        return client.post('/contest/end/signin', qs.stringify({
            contestId,
        }))
    },
    addRemarkPlayer(contestId, joinId, remarks) {
        return client.post('/contest/player/remarks', qs.stringify({
            contestId,
            joinId,
            remarks
        }))
    },
    proxySignin(contestId, joinId) {
        return client.post('/contest/proxy/player/signin', qs.stringify({
            contestId,
            joinId
        }))
    },
    getSubareaAndJudge(contestId) {
        return client.post('/contest/get/subareaAndJudge', qs.stringify({
            contestId
        }))
    },
    saveSubareaAndJudge(contestId,secondJudge,sessionCount,sortType,subareaCount,subareaJudge) {
        return client.post('/contest/save/subareaAndJudge', qs.stringify({
            contestId,
            secondJudge,
            sessionCount,
            sortType,
            subareaCount,
            subareaJudge
        }))
    },
    getDrawInfos(contestId) {
        return client.post('/contest/get/draw', qs.stringify({contestId}))
    },
    startDraw(contestId,info,session){
        return client.post('/contest/start/draw', qs.stringify({
            contestId,
            info,
            session
        }))
    },
    saveDrawInfo(contestId,info){
        return client.post('/contest/save/draw', qs.stringify({
            contestId,
            info,
        }))
    },
    deleteDraw(contestId,session){
        return client.post('/contest/draw/delete', qs.stringify({
            contestId,
            session,
        }))
    },
    startLottery(contestId, num, removedIds, repeat) {
        return client.post('/contest/lottery/start', qs.stringify({
            contestId,
            num,
            removedIds,
            repeat,
            remove:'-1'
        }))
    },
    getLotteryList(contestId) {
        return client.post('/contest/lottery/list', qs.stringify({
            contestId
        }))
    },
    getContestLiveInfo(contestId){
        return client.post('/contest/session/result', qs.stringify({contestId}))
    },
    searchPlayer(content,contestId){
        return client.post('/contest/search/player', qs.stringify({
            content,
            contestId
        }))
    },
    searchPlayerContestInfo(playerId){
        return client.post('/contest/rank/item', qs.stringify({playerId}))
    },
    getSubareaInfo(contestId,session,subarea,orderby){
        return client.post('/contest/session/get', qs.stringify({
            contestId,
            session,
            subarea,
            orderby
        }))
    },
    savePlayerScore(contestId,id,num,weight){
        return client.post('/contest/session/save/result', qs.stringify({
            contestId,
            id,
            num,
            weight
        }))
    },
    punishPlayerScore(contestId,id,playerId,punishRemark,punishScore){
        return client.post('/contest/session/save/punish', qs.stringify({
            contestId,
            id,
            playerId,
            punishRemark,
            punishScore
        }))
    },
    proxyPlayerDraw(contestId,id){
        return client.post('/contest/player/proxy/start/draw', qs.stringify({
            contestId,
            id
        }))
    },
    getRankInfo(contestId){
        return client.post('/contest/rank/list', qs.stringify({
            contestId,
        }))
    },
    finishContest(contestId){
        return client.post('/contest/finish', qs.stringify({
            contestId,
        }))
    },
    countContest(contestId){
        return client.post('/contest/session/draw/count', qs.stringify({
            contestId,
        }))
    },
    playerStartDraw(contestId,session){
        return client.post('/contest/player/start/draw', qs.stringify({
            contestId,
            session
        }))
    },
    playerDrawHistory(contestId){
        return client.post('/contest/player/my/draw', qs.stringify({
            contestId,
        }))
    }
}
